import * as tslib_1 from "tslib";
import { PipeTransform } from '@angular/core';
var DataFilterPipe = /** @class */ (function () {
    function DataFilterPipe() {
    }
    DataFilterPipe.prototype.transform = function (array, args) {
        array = array || [];
        var returnFilterCount = (args.length > 1 && args[1]);
        if (args === null || typeof args === 'undefined' || args.length === 0 ||
            args[0] === undefined || args[0].searchTerm === 'undefined'
            || args[0].searchTerm === null || args[0].searchTerm.trim() === '') {
            if (returnFilterCount) {
                args[1].Count = array.length;
            }
            return array;
        }
        var filtered = array.filter(function (item) {
            var e_1, _a;
            var isMatch = false;
            try {
                for (var _b = tslib_1.__values(Object.keys(args[0].keys)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    var propName = args[0].keys[key];
                    if (item.hasOwnProperty(propName) && item[propName] !== null) {
                        isMatch = item[propName].toString().toLowerCase().search(args[0].searchTerm.toLowerCase().trim()) >= 0;
                    }
                    if (isMatch) {
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return isMatch;
        });
        if (returnFilterCount) {
            args[1].Count = filtered.length;
        }
        return filtered;
    };
    return DataFilterPipe;
}());
export { DataFilterPipe };
